{
  "id": "b2-vocabulary-12",
  "name": "B2 Frequency Band 12 (551-600)",
  "description": "B2 level French frequency vocabulary",
  "examGrade": "B2",
  "difficulty": "advanced",
  "source": "French subtitle frequency list",
  "sourceUrl": "https://github.com/hermitdave/FrequencyWords",
  "category": "general",
  "words": [
    {
      "id": "fr:vocab:3552:carol",
      "word": "carol",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5414
    },
    {
      "id": "fr:vocab:3553:finale",
      "word": "finale",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5405
    },
    {
      "id": "fr:vocab:3554:culture",
      "word": "culture",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5401
    },
    {
      "id": "fr:vocab:3555:revienne",
      "word": "revienne",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5400
    },
    {
      "id": "fr:vocab:3556:pensiez",
      "word": "pensiez",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5399
    },
    {
      "id": "fr:vocab:3557:p-nis",
      "word": "pénis",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5399
    },
    {
      "id": "fr:vocab:3558:crois-tu",
      "word": "crois-tu",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5397
    },
    {
      "id": "fr:vocab:3559:d-u",
      "word": "déçu",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5395
    },
    {
      "id": "fr:vocab:3560:production",
      "word": "production",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5395
    },
    {
      "id": "fr:vocab:3561:bible",
      "word": "bible",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5393
    },
    {
      "id": "fr:vocab:3562:pierres",
      "word": "pierres",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5391
    },
    {
      "id": "fr:vocab:3563:gants",
      "word": "gants",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5389
    },
    {
      "id": "fr:vocab:3564:sous-sol",
      "word": "sous-sol",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5386
    },
    {
      "id": "fr:vocab:3565:beth",
      "word": "beth",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5384
    },
    {
      "id": "fr:vocab:3566:oeufs",
      "word": "oeufs",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5384
    },
    {
      "id": "fr:vocab:3567:nina",
      "word": "nina",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5383
    },
    {
      "id": "fr:vocab:3568:pouvons-nous",
      "word": "pouvons-nous",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5381
    },
    {
      "id": "fr:vocab:3569:rumeurs",
      "word": "rumeurs",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5380
    },
    {
      "id": "fr:vocab:3570:int-r-ts",
      "word": "intérêts",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5379
    },
    {
      "id": "fr:vocab:3571:regardais",
      "word": "regardais",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5375
    },
    {
      "id": "fr:vocab:3572:indice",
      "word": "indice",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5374
    },
    {
      "id": "fr:vocab:3573:minist-re",
      "word": "ministère",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5374
    },
    {
      "id": "fr:vocab:3574:brad",
      "word": "brad",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5372
    },
    {
      "id": "fr:vocab:3575:t-moignage",
      "word": "témoignage",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5371
    },
    {
      "id": "fr:vocab:3576:ufs",
      "word": "œufs",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5370
    },
    {
      "id": "fr:vocab:3577:effrayant",
      "word": "effrayant",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5368
    },
    {
      "id": "fr:vocab:3578:fouiller",
      "word": "fouiller",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5367
    },
    {
      "id": "fr:vocab:3579:prier",
      "word": "prier",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5364
    },
    {
      "id": "fr:vocab:3580:diane",
      "word": "diane",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5364
    },
    {
      "id": "fr:vocab:3581:actrice",
      "word": "actrice",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5363
    },
    {
      "id": "fr:vocab:3582:suspects",
      "word": "suspects",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5362
    },
    {
      "id": "fr:vocab:3583:soirs",
      "word": "soirs",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5362
    },
    {
      "id": "fr:vocab:3584:pisser",
      "word": "pisser",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5360
    },
    {
      "id": "fr:vocab:3585:causer",
      "word": "causer",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5359
    },
    {
      "id": "fr:vocab:3586:finira",
      "word": "finira",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5356
    },
    {
      "id": "fr:vocab:3587:entrep-t",
      "word": "entrepôt",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5353
    },
    {
      "id": "fr:vocab:3588:oxyg-ne",
      "word": "oxygène",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5353
    },
    {
      "id": "fr:vocab:3589:s",
      "word": "s.",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5348
    },
    {
      "id": "fr:vocab:3590:marshall",
      "word": "marshall",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5347
    },
    {
      "id": "fr:vocab:3591:west",
      "word": "west",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5346
    },
    {
      "id": "fr:vocab:3592:inqui-tes",
      "word": "inquiètes",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5345
    },
    {
      "id": "fr:vocab:3593:conclu",
      "word": "conclu",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5344
    },
    {
      "id": "fr:vocab:3594:souviens-toi",
      "word": "souviens-toi",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5342
    },
    {
      "id": "fr:vocab:3595:devras",
      "word": "devras",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5339
    },
    {
      "id": "fr:vocab:3596:francisco",
      "word": "francisco",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5339
    },
    {
      "id": "fr:vocab:3597:salade",
      "word": "salade",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5335
    },
    {
      "id": "fr:vocab:3598:indique",
      "word": "indique",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5332
    },
    {
      "id": "fr:vocab:3599:matin-e",
      "word": "matinée",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5332
    },
    {
      "id": "fr:vocab:3600:flotte",
      "word": "flotte",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5330
    },
    {
      "id": "fr:vocab:3601:uns",
      "word": "uns",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 5327
    }
  ]
}